<template>
    <activation-preview-provider
        v-slot="{
            brief,
        }"
        :module-name="moduleName"
    >
        <activation-brief-view
            v-if="brief"
            :brief="brief"
            :is-preview="true"
        />
        <g-loader v-else type="fixed" />
    </activation-preview-provider>
</template>

<script>
    import ActivationPreviewProvider from '../../providers/preview-providers/ActivationPreviewProvider';
    import ActivationBriefView from '../../data-views/activation-briefs/ActivationBriefView';
    import {NAME_OVERVIEW} from '../../../constants/activation-brief-steps';
    import PageMask from '../../library/PageMask';

    export default {
        name:       'ActivationOverviewPreviewView',
        components: {
            ActivationPreviewProvider,
            ActivationBriefView,
            PageMask,
        },
        data() {
            return {
                moduleName: NAME_OVERVIEW,
            };
        },
    };
</script>
